import { render, staticRenderFns } from "./seal.vue?vue&type=template&id=fc5bbf12"
import script from "./seal.vue?vue&type=script&lang=js"
export * from "./seal.vue?vue&type=script&lang=js"
import style0 from "./seal.vue?vue&type=style&index=0&id=fc5bbf12&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports